import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "../Header";

export function PageLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);

  return (
    <div className="bg-black min-h-[100dvh] h-max font-poppins">
      <Header />
      <Outlet />
    </div>
  )
}
